<template>
  <div>
    <div class="tab-container">
      <header class="d-flex justify-content-center py-3">
        <ul class="nav nav-pills nav-fill">
          <li class="nav-item">
            <router-link :to="`${parentRoute}`" class="nav-link" :class="endsWith(parentRoute)"
              >Overview
            </router-link>
          </li>

          <li class="nav-item">
            <router-link :to="`${parentRoute}/trades`" class="nav-link" :class="endsWith('trades')"
              >Trades & Registrations
            </router-link>
          </li>

          <li class="nav-item">
            <router-link
              :to="`${parentRoute}/contacts`"
              class="nav-link"
              :class="endsWith('contacts')"
              >Contacts
            </router-link>
          </li>

          <li class="nav-item">
            <router-link :to="`${parentRoute}/notes`" class="nav-link" :class="endsWith('notes')"
              >Internal Notes
            </router-link>
          </li>

          <li class="nav-item">
            <router-link :to="`${parentRoute}/emails`" class="nav-link" :class="endsWith('emails')"
              >Emails
            </router-link>
          </li>

          <li class="nav-item" v-if="isWatchlistViewer">
            <router-link :to="`${parentRoute}/watchlist`" class="nav-link" :class="endsWith('watchlist')"
              >Watchlist
            </router-link>
          </li>

          <li class="nav-item">
            <router-link
              :to="`${parentRoute}/formatted-activity-logs`"
              class="nav-link"
              :class="endsWith('formatted-activity-logs')"
              >Activity Logs
            </router-link>
          </li>

          <li class="nav-item">
            <router-link
              :to="`${parentRoute}/raw-activity-logs`"
              class="nav-link"
              :class="endsWith('raw-activity-logs')"
              >Raw Activity Logs
            </router-link>
          </li>

           <li class="nav-item" v-if="isVerificationViewer">
            <router-link
              :to="`${parentRoute}/verification`"
              class="nav-link"
              :class="includes('verification')"
              >Verification
            </router-link>
          </li>

        </ul>
      </header>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SchemeBusinessTabs',
  data() {
    return {
      env: import.meta.env.VITE_MODE,
    };
  },
  computed: {
    parentRoute() {
      let baseRoute = 'scheme-business';
      if (this.$route.meta.pendingLicences) {
        baseRoute = 'pending-licences';
      }
      return `/${baseRoute}/${this.$route.params.schemeId}/${this.$route.params.schemeBusinessId}`;
    },
    currentAccount() {
      return this.$store.state.auth.account;
    },
    isWatchlistViewer() {
      return this.currentAccount && this.currentAccount.roles
        ? this.currentAccount.roles.includes('WatchlistViewer')
        : false;
    },
    isVerificationViewer() {
      return this.currentAccount && this.currentAccount.roles
        ? this.currentAccount.roles.includes('VerificationViewer')
        : false;
    },
  },
  methods: {
    includes(str) {
      return this.$route.path.includes(str) ? 'active' : '';
    },
    endsWith(str) {
      return this.$route.path.endsWith(str) ? 'active' : '';
    },
  },
};
</script>
